import { cn } from '@/shared/lib'
import { Notice } from '@/shared/ui'

export type Props = {
  className?: string
  isOldRefundTerms: boolean
}

export const RefundTermNotice = ({ isOldRefundTerms, className }: Props) => {
  const cancelFee = isOldRefundTerms
    ? '임대료의 10%'
    : '임대료와 계약 수수료 합계의 10%'

  return (
    <div className={cn('px-6', className)}>
      <Notice.Title hasIcon={false} />
      <Notice.List gap={false}>
        <Notice.Item>
          결제 당일 취소 시, 환불 규정과 관계 없이 {cancelFee}만 위약금으로
          부과됩니다.
          <br />
          단, 무료 취소 기간에 해당하는 경우 전액 환불됩니다.
        </Notice.Item>
        <Notice.Item>
          계약 취소 시 관리비, 청소비, 보증금은 전액 환불됩니다.
        </Notice.Item>
        <Notice.Item>환불 규정은 호스트의 설정에 따라 달라집니다.</Notice.Item>
        <Notice.Item>
          호스트의 사정으로 계약이 취소될 경우, 동일한 기준의 위약금을 호스트가
          게스트에게 지급합니다.
        </Notice.Item>
      </Notice.List>
    </div>
  )
}
